import React from 'react'
import styles from './ProductPageLayout.module.css'
import { Breadcrumb } from '~/components/Breadcrumb/Breadcrumb'
import ProductDescription from '~/components/ProductDescription/ProductDescription'
import { productTypes } from '~/components/ProductTypesList/productTypes'
import { useRouter } from '~/hooks/useRouter'
import { ProductDescriptionDetails } from '~/components/ProductDescription/ProductDescriptionDetails'
interface ProductPageLayoutProps {
  children: React.ReactNode
  showBreadcrumbs?: boolean
  fullWidth?: boolean
  /**
   * Render the shared "Despre produs" (ProductDescriptionDetails) block.
   * Configurator pages set this to false because <SeoContentSection> renders
   * that exact block prerender-safe, before the footer — rendering it here too
   * would duplicate it. /product/* preview pages keep the default (true).
   */
  showDescription?: boolean
}
export const ProductPageLayout: React.FC<ProductPageLayoutProps> = ({
  children,
  showBreadcrumbs = true,
  fullWidth = false,
  showDescription = true,
}) => {
  const router = useRouter()

  const strippedPath = router.pathname.replace('/[locale]', '')
  const productType = productTypes.find(({ link }) => link === strippedPath)

  return (
    <>
      <div className={fullWidth ? undefined : styles.container}>
        {showBreadcrumbs && (
          <div className={styles.breadcrumbContainer}>
            <Breadcrumb
              items={[
                { label: 'homepage.configurator.breadcrumb.1', link: '/' },
                {
                  label: 'homepage.configurator.breadcrumb.2',
                  link: '/catalog',
                },
                ...(productType
                  ? [{ label: productType.name, link: strippedPath }]
                  : []),
              ]}
            />
          </div>
        )}
        <div>{children}</div>
      </div>
      {showDescription && (
        <>
          <br />
          <br />
          <div className={styles.productDescriptionContainer}>
            <ProductDescription
              sections={ProductDescriptionDetails}
              heading={'productPage.details.title'}
            />
          </div>
        </>
      )}
    </>
  )
}
